/*
 * @Author: Pension 744056574@qq.com
 * @Date: 2022-08-26 17:21:58
 * @LastEditors: Pension 744056574@qq.com
 * @LastEditTime: 2023-06-26 16:06:35
 * @FilePath: /mzc-frontend-pc/packages/share/utils/addTopNavPath.ts
 * @Description:增加顶部路径的函数
 *
 */

import localforage from "localforage";
import router from "@/router";
import { useBtnPermission, getBtnListByBtnType } from "./btnPermission";
export default function addPath(path: string, name: string, routerFn: any, query?: any) {
  if (typeof routerFn !== "function") {
    //强制用新写法，以后删除这个代码
    // router.push({ path: "/" });
    localStorage.removeItem("token");
    alert("请使用写的跳转写法");
    return;
  }

  let current3LevelMenu = {
    url: "",
    query: {},
    name: "",
    level: 0,
    actions: [],
    allPath: [],
    btnList: [],
  };
  let cacheCurrent3LevelMenu = localStorage.getItem("current3LevelMenu");
  if (cacheCurrent3LevelMenu) {
    current3LevelMenu = JSON.parse(cacheCurrent3LevelMenu);
  }

  let btnList: any = [];
  if (path.indexOf("list") != -1) {
    btnList = getBtnListByBtnType(1);
    //存储列表页面按钮权限
  } else if ((path.indexOf("add") != -1 && !path.includes("addr")) || path.indexOf("edit") != -1) {
    btnList = getBtnListByBtnType(2);
    //跳转到新增/编辑页面
  } else if (path.indexOf("view") != -1) {
    btnList = getBtnListByBtnType(3);
    //跳转详情页面
  } else {
    btnList = getBtnListByBtnType(1);
  }

  localStorage.setItem("btnList", JSON.stringify(btnList));

  //前往页面的等级，其实也可以是3级，比如导出组件跳转到下载列表
  let canFindInLoginLevel3Menu = false; //在登录菜单的3级菜单中能找到
  let cacheCurSystem = localStorage.getItem("cur-system");
  if (cacheCurSystem) {
    let curSystemdata = JSON.parse(cacheCurSystem);
    let fn = (data: any) => {
      if (data.length) {
        data.forEach((item: any) => {
          if (item.url && item.url == path) {
            canFindInLoginLevel3Menu = true;
            // item.query=query
            const updateSystemAnd3LevelMenuEvent = new CustomEvent("updateSystemAnd3LevelMenu", {
              detail: {
                child: item,
              },
            });
            window.dispatchEvent(updateSystemAnd3LevelMenuEvent);

            return;
          } else {
            if (item.childs && item.childs.length) {
              fn(item.childs);
            }
          }
        });
      }
    };
    fn(curSystemdata.childs);
  }
  if (canFindInLoginLevel3Menu) {
    return;
  }

  let obj = {
    url: path,
    listUrl: current3LevelMenu.url,
    listQuery: current3LevelMenu.query,
    listName: current3LevelMenu.name,
    actions: current3LevelMenu.actions,
    allPath: current3LevelMenu.allPath,
    level: current3LevelMenu.level + 1,
    btnList: btnList,
    name: name,
    query: query,
    isClick: true,
    hover: false,
  };

  localStorage.setItem("current3LevelMenu", JSON.stringify(obj));

  let menuPath = [{ name: current3LevelMenu.name, path: current3LevelMenu.url, query: current3LevelMenu.query }];
  if (!canFindInLoginLevel3Menu) {
    menuPath.push({ path, name, query });
  }

  localStorage.setItem("menuPath", JSON.stringify(menuPath));

  localforage.getItem("allActive3LevelMenuData").then((data: any) => {
    if (data && data.length) {
      data.forEach((item: any) => (item.isClick = false));
      let curIndex: number = -1;
      for (let i = 0; i < data.length; i++) {
        let item = data[i];
        item.isClick = false;
        if (item.url == path) {
          curIndex = i;
          obj.query = query;
          data.splice(i, 1, obj);
          break;
        }
      }
      if (curIndex == -1) {
        data.push(obj);
      }
    } else {
      data = [];
      data.push(obj);
    }

    routerFn();
    localforage.setItem("allActive3LevelMenuData", data).then((value: any) => {
      const tabItem = new CustomEvent("allActive3LevelMenuDataEvent", {
        detail: { allActive3LevelMenuData: value },
      });
      window.dispatchEvent(tabItem);
    });
  });
}
